import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Tree } from 'antd'

import menuList from '../../configs/menuConfig'

const Item = Form.Item

export default class roleAuthModify extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    state = {
        treeData: [],
        checkedKeys: []
    }

    static propTypes = {
        role: PropTypes.object
    }

    constructor(props) {
        super(props)
        const { menus } = this.props.role
        const checkedKeys = this.get_list_checked_menus(menus)
        this.state = { checkedKeys }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { menus } = nextProps.role
        const checkedKeys = this.get_list_checked_menus(menus)
        this.setState({ checkedKeys })
    }

    UNSAFE_componentWillMount() {
        this.get_list_all_menus(menuList)
    }

    // 數據配置設定 //////////////////////////////////////////////   

    get_list_checked_menus = (menus) => {
        const items = []
        if (menus) {
            menus.forEach(element => {
                items.push(element.linkUrl)
            });
        }
        return items
    }

    get_list_all_menus = (menuList) => {
        this.setState({ treeData: menuList })
    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_checked_tree_menu = (checkedKeys) => {
        //console.log(checkedKeys)
        this.setState({ checkedKeys })
    }

    // 外部接收方法 /////////////////////////////////////////////    

    // 提供父組件存取數據
    output_menus = () => {
        const checkedKeys = this.state.checkedKeys
        return checkedKeys
    }

    ///////////////////////////////////////////////////////////// 

    render() {
        const { treeData, checkedKeys } = this.state
        const { role } = this.props
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 15 }
        }
        return (
            <div>
                <Item {...formItemLayout} label="角色名稱">
                    <Input value={role.roleName} disabled />
                </Item>
                <Tree
                    checkable
                    defaultExpandAll={true}
                    treeData={treeData}
                    checkedKeys={checkedKeys}
                    onCheck={this.handle_checked_tree_menu}
                />
            </div>
        )
    }
}